import { render, staticRenderFns } from "./VehiclesListView.vue?vue&type=template&id=4abd909e&"
import script from "./VehiclesListView.vue?vue&type=script&lang=js&"
export * from "./VehiclesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports